// extracted by mini-css-extract-plugin
export default {"dotWrapper":"Dot_dotWrapper__1j6nU","dot":"Dot_dot__6POyl"};